import { Dialog } from '@platform/ui';
import type { IFilePreviewDialogProps } from './IFilePreviewDialogProps';

/** Попередній перегляд зображення або PDF (UIUX/field-types/file «Preview images and PDFs»): широке вікно, вміст за blob-адресою. */
export function FilePreviewDialog({ preview, onClose }: IFilePreviewDialogProps) {
  const image = preview.mimeType.startsWith('image/');
  return (
    <Dialog title={preview.fileName} size="lg" onClose={onClose}>
      {image
        ? <img className="fc-preview fc-preview--image" src={preview.url} alt={preview.fileName} />
        : <iframe className="fc-preview" src={preview.url} title={preview.fileName} />}
    </Dialog>
  );
}
